import { render, staticRenderFns } from "./IGV2ChannelDetail.vue?vue&type=template&id=b1daacaa&scoped=true"
import script from "./IGV2ChannelDetail.vue?vue&type=script&lang=js"
export * from "./IGV2ChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./IGV2ChannelDetail.vue?vue&type=style&index=0&id=b1daacaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1daacaa",
  null
  
)

export default component.exports